import { Component, OnInit, Input } from '@angular/core';

import { FormInit } from '../model/form/form-properties/form-init';
import { InterfaceElement } from '../model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { InterfaceElementTypes } from '../model/interfaceElement/interfaceElement-properties/interfaceElement-type';

import { CosyAppStateDataControllerService } from '../service/controller/cosy-app-state-data-controller.service';

@Component({
  selector: 'app-cosy-custom-form',
  templateUrl: './cosy-custom-form.component.html',
  styleUrls: ['./cosy-custom-form.component.css']
})
export class CosyCustomFormComponent implements OnInit {

  private ieObj = {};
  public interfaceElements : InterfaceElement[];

  /*Inputs From Master*/
  @Input() cosyFormInitProperties : FormInit;

  constructor(
              private cosyAppStateDataControllerService : CosyAppStateDataControllerService
             ) {}

  ngOnInit() {}

  ngDoCheck() {
    if(typeof this.cosyFormInitProperties.InterfaceFormElementList!== 'undefined'){
     if(this.cosyFormInitProperties.InterfaceFormElementList.length > 0 ){
       for(let ie of this.cosyFormInitProperties.InterfaceFormElementList){
             if(ie.TypeDID == InterfaceElementTypes.FormEntity){
               this.interfaceElements = ie.InterfaceElements;
               this.ieObj = this.cosyAppStateDataControllerService.getKeyedInterfaceElements(this.interfaceElements);
           }
         }
       }
     }
  }
}

